//API Domain Name
import { showConsoleError, showConsoleMessage } from "../util/ConsoleMessage";
export const apiDomainName = "joker5api231.com/JokerPlus/Main/v6";
export const BASE_URI = `https://${apiDomainName}`;

export const getLocalApiUrl = () => {
  const localApiLogged = localStorage.getItem("local_api_logged");
  if (localApiLogged) {
    try {
      return localApiLogged.slice(0, -1) || null;
    } catch (error) {
      showConsoleError("Error parsing local_api_logged:", error);
    }
  } else {
    showConsoleMessage("No data in localStorage.");
  }
  return null;
};

export const getBaseUri = () => {
  showConsoleMessage("Using Default API URL:", BASE_URI);
  return BASE_URI;
};

export const Endpoint = {
  Login: `${getBaseUri()}/Member/LoginByUsername`,
  VerifyAccountForResetPassword: `${getBaseUri()}/Member/VerifyAccountForResetPassword`,
  SendVerifyCode: `${getBaseUri()}/Member/SendVerifyCode`,
  VerifyCode: `${getBaseUri()}/Member/VerifyCode`,
  ResetPassword: `${getBaseUri()}/Member/ResetPassword`,
  CheckEmail: `${getBaseUri()}/Member/CheckEmail`,
  VerifyEmail: `${getBaseUri()}/Member/VerifyEmail`,
  CheckUsername: `${getBaseUri()}/Member/CheckUsername`,


  
}

//API Constants
export const notificationToken = String(
  process.env.REACT_APP_NOTIFICATION_TOKEN
);
export const sha256Salt = String(process.env.REACT_APP_SHA256SALT);
export const secretKey = String(process.env.REACT_APP_SECRET_KEY);
export const apiKey = String(process.env.REACT_APP_API_KEY || "");

